import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { WebApiService, JsonFileService } from "../../../_libs/web-api";
import { BaseWebApiService } from "./-base-webapi.service";

@Injectable({
	providedIn: "root",
})
export class MuleCreateQuoteService extends BaseWebApiService {
	constructor(
		private webApiService: WebApiService,
		private __jsonFileService: JsonFileService
	) {
		super();
	}

	public muleUpdateQuoteTargetedPromo(
		promoDiscountCode: string,
		quoteId: string,
		quoteItemId: string
	): Observable<any> {
		const url = `quoteMgmt/quote/${quoteId}/promo`;
		const body = {
			promocode: promoDiscountCode,
			quoteItemId: quoteItemId,
			action: "add",
		};
		return this.webApiService.postMS(url, body);
	}
}
